module.exports = __webpack_public_path__ + "static/media/YM04_5.da8ccfeb.jpg";